import './filter.directive.ajscss';

import { element, isDefined } from 'angular';

import templateUrl from './filter.directive.html';

function filterCtrl($transclude) {
  $transclude((clone, scope) => {
    element('<div>').append(clone).html();
    scope.$on('$destroy', () => {
      clone.remove();
    });
  });
}

export let FilterDirective = () => ({
  restrict: 'E',
  require: 'ngModel',
  templateUrl,
  transclude: true,
  controller: ['$transclude', filterCtrl],
  scope: {
    hasFilter: '=',
    isFilterDisabled: '=',
  },
  link: (scope, elem, attrs) => {
    scope.ngModel = (!scope.isFilterDisabled && scope.$eval(attrs.ngModel)) || false;
    scope.ngModel = scope.$eval(attrs.ngModel) || false;
    scope.ngCallback = attrs.ngCallback || null;
    scope.label = isDefined(scope.label) ? scope.label : '';
    scope.toggleFilter = () => {
      scope.ngModel = !scope.ngModel;
      if (scope.ngModel && attrs.focus) {
        setTimeout(() => {
          const container = document.getElementById(attrs.focus);
          if (container) {
            container.focus();
          }
        }, 1000);
      }
    };
    scope.name = isDefined(attrs.formName) ? attrs.formName : '';

    scope.$watch('isFilterDisabled', () => {
      scope.ngModel = !scope.isFilterDisabled && scope.ngModel;
    });

    scope.submit = e => {
      scope.$eval(scope.ngCallback);
      e.preventDefault();
      return false;
    };

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
    });
    elem.on('$destroy', () => {
      scope.$destroy();
    });
  },
});

export default 'cngFilter';
